import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { resetPassword } from "../../api/auth.api";
import { toast } from "react-toastify";

const ResetPassword = () => {

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const token = searchParams.get("token");
  const email = searchParams.get("email");
  const role = searchParams.get("role");

  const [values, setValues] = useState({
    password: "",
    confirmPassword: ""
  });

  const handleChange = (e) => {
    setValues({
      ...values,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (values.password !== values.confirmPassword) {
      return toast.error("Passwords do not match");
    }

    try {
      const res = await resetPassword({
        email,
        role,
        token,
        password: values.password
      });
      toast.success(res.data.message);
      navigate("/");
    } catch (e) {
      toast.error(e.response?.data?.message || "Reset failed");
    }
  };

  const inputStyle = {
    backgroundColor: "#f9fafb",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    padding: "12px 16px",
    width: "100%",
    marginBottom: "20px",
    outline: "none",
    fontSize: "clamp(14px, 1.2vw, 16px)"
  };

  return (
    <div
      style={{
        maxWidth: "500px",
        width: "90%",
        margin: "clamp(40px, 8vh, 80px) auto",
        backgroundColor: "#fff",
        padding: "clamp(25px, 5vw, 40px)",
        borderRadius: "12px",
        border: "1px solid #e5e7eb",
        boxShadow: "0 10px 25px rgba(0,0,0,0.05)"
      }}
    >

      <h3
        className="fw-bold mb-2"
        style={{ 
          color: "#112347",
          fontSize: "clamp(20px, 3vw, 28px)"
        }}
      >
        Reset Password
      </h3>

      <p className="text-muted mb-4" style={{ fontSize: "clamp(13px, 1vw, 15px)" }}>
        Enter your new password
      </p>

      <form onSubmit={handleSubmit}>

        <input
          type="password"
          name="password"
          placeholder="New Password"
          value={values.password}
          onChange={handleChange}
          style={inputStyle}
          required
        />

        <input
          type="password"
          name="confirmPassword"
          placeholder="Confirm Password"
          value={values.confirmPassword}
          onChange={handleChange}
          style={inputStyle}
          required
        />

        <button
          type="submit"
          className="btn w-100 py-3 fw-bold text-white"
          style={{ 
            backgroundColor: "#112347",
            fontSize: "clamp(14px, 1.2vw, 16px)"
          }}
        >
          Reset Password
        </button>

      </form>

    </div>
  );

};

export default ResetPassword;